  <div class="header-container">
    <div display="flex">
      @if (!_appsService.selectedApp?.image) {
      <div class="chip chip-round chip-x-large">
        <span> {{ _appsService?.userInitials }} </span>
      </div>
      }
      @if (_appsService.selectedApp && _appsService.selectedApp?.image) {
      <div class="chip chip-round chip-x-large chip-image"
        [ngStyle]="{'background-image': 'url(' + _appsService.selectedApp?.image + ')'}">
      </div>
      }
    </div>
    <div class="details">
      <span>
        <h4>
          {{ _appsService.selectedApp?.name }}
          @if (_appsService.selectedApp?.clientMetadata?.internalOnly) {
          <span>- ({{ 'Internal_Only' | translate
            }})</span>
          }
        </h4>
        @if (_appsService.selectedApp?.description) {
        <div [matTooltip]="_appsService.selectedApp?.description">
          <div class= "description"> {{ _appsService.selectedApp?.description }}</div>
        </div>
        }
        @if (!_appsService.selectedApp?.description) {
        <p class="default-description">
          {{ 'APP_DETAILS.default_description' | translate }}
        </p>
        }
      </span>
    </div>
  </div>
